import Client from './../Clients/axiosClient'
const resource = '/api/carts'

export default {
  get () {
    return Client.get(`${resource}`)
  },
  getItem (id) {
    return Client.get(`${resource}/${id}`)
  },
  /**
   * Add product to cart
   * @param {Object}  payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  create (payload) {
    return Client.post(`${resource}`, payload)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
}
